import { useState } from 'react'
import { FormGroup, Label, Col } from 'reactstrap'
import classNames from 'classnames'

const FilterFormGroup = ({
  column,
  render,
  ...rest
}) => {
  return (
    <FormGroup>
      {_.get(column, 'filter.displayName', true) && <Label for='react-select'>{column.name}</Label>}
      {render(column, rest)}
    </FormGroup>
  )
}

const FilterFormColumn = ({
  column,
  forced,
  hidden,
  breakPoints,
  render
}) => {
  const [isFluid, setIsFluid] = useState(false)
  const _breakPoints = isFluid ? { xs: 12 } : {...breakPoints}
  return (
    <Col {..._breakPoints} className={classNames({ hidden: forced || hidden })}>
      <FilterFormGroup 
        column={column}
        render={render}
        setIsFluid={setIsFluid}
      />
    </Col>
  )
}

export default FilterFormColumn